/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsDiscountResponse
 */
export interface IdentityMelcoModelsDiscountResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsDiscountResponse
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsDiscountResponse
     */
    discount_amount?: number;
}

export function IdentityMelcoModelsDiscountResponseFromJSON(json: any): IdentityMelcoModelsDiscountResponse {
    return IdentityMelcoModelsDiscountResponseFromJSONTyped(json, false);
}

export function IdentityMelcoModelsDiscountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsDiscountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discount_amount': !exists(json, 'discount_amount') ? undefined : json['discount_amount'],
    };
}

export function IdentityMelcoModelsDiscountResponseToJSON(value?: IdentityMelcoModelsDiscountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'discount_amount': value.discount_amount,
    };
}


